const Config = {
    genAIEnabled : false,
    matomoURL : 'https://dev-trk.testmaya.com/',
    matomoSiteID: 10
};

export default Config